/**
 * @Description 区域保护抽屉
 */
import { FC, useEffect, useMemo, useState } from 'react';
// import V2Drawer from '../../Feedback/V2Drawer/index';
import SkeletonDetail from '../../Skeleton/SkeletonDetail/index';
import V2Container from '../../Data/V2Container';
import Title from './components/Title';
import Map from './components/Map';
import ApplyHint from './components/ApplyHint';
import ApprovalNodes from '../ExpandStore/ApprovalNodes';
import Info from './components/Info';
import ConflictTable from './components/ConflictTable';
import { getApprovalInfo, getConflictList } from '@/common/api/areaProtect';
import { getApprovalDetail } from '@/common/api/expandStore/approveworkbench';
import { useSelector } from 'react-redux';
const AreaProtection:FC<any> = ({
  id,
  // open,
  setOpen, // 成功及取消的情况
  onComplete, // 成功的情况，更适合作为外层的刷新回调
  approvalId, // 是否进入审批状态
  showHeader = true,
}) => {
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const [loadingSk, setLoadingSk] = useState<any>(true); // 骨架屏加载
  const [approvalDetail, setApprovalDetail] = useState<any>();
  const [conflictInfo, setConflictList] = useState<any>(null);// 区域保护信息

  /**
    * @description 是否摩可多租户
  */
  const isMKD = useMemo(() => {
    return !!tenantCheckData?.isMkd;
  }, [tenantCheckData]);

  // 获取区域保护信息
  const handleGetInfo = () => {
    const getConflictInfoApi = approvalId
      ? getApprovalInfo({ id: approvalId })
      : getConflictList({ chancePointId: id });

    // 获取冲突区域数据
    getConflictInfoApi
      .then((val) => {
        if (approvalId) {
          setConflictList(val.standardProtectFormResponse);
        } else {
          setConflictList(val);
        }
      })
      .finally(() => {
        setLoadingSk(false);
      });
  };

  const handleGetApprovalDetail = async() => {
    const data = await getApprovalDetail({ id: approvalId });
    setApprovalDetail(data);
  };

  useEffect(() => {
    // 没有id或者没有打开直接return
    if (!id || !open) return;
    handleGetInfo();
    approvalId && handleGetApprovalDetail();
  }, [id, approvalId, open]);

  return loadingSk
    ? <SkeletonDetail/>
    : <V2Container
      extraContent={{
        top: showHeader ? <Title
          // approvalPermissions={approvalId ? approvalDetail?.permissions : null}
          isReject={approvalDetail?.status === 4}// 是否驳回
          approvalId={approvalId}
          conflictInfo={conflictInfo}
          setOpen={setOpen}
          onComplete={onComplete}
          id={id}
          approvalDetail={approvalDetail}
          isMKD={isMKD}
        /> : <></>
      }}
      style={{ height: 'calc(100% - 48px)' }}
    >
      {/* 当含有审批状态的时候渲染 */}
      {
        showHeader && approvalDetail && Object.keys(approvalDetail).length > 0
          ? <ApprovalNodes detail={approvalDetail} />
          : <></>
      }
      {/* 申请提示 */}
      <ApplyHint
        conflictInfo={conflictInfo}
        isApplying={approvalId}
        isMKD={isMKD}
      />
      {/* 冲突情况 */}
      {conflictInfo?.conflictRegionItemResponseList?.length && !isMKD
        ? <ConflictTable
          distanceType={conflictInfo?.distanceType}
          conflictRegionItemResponseList={conflictInfo?.conflictRegionItemResponseList}/>
        : <></>}
      {/* 地图内容 */}
      <Map conflictInfo={conflictInfo} isMKD={isMKD}/>
      {/* 点位信息 */}
      <Info conflictInfo={conflictInfo}/>

    </V2Container>;
};
export default AreaProtection;
